import { memo, useCallback, useMemo, useState } from 'react'
import { useGlobalTick } from 'hooks/useGlobalTick'
import { useTranslation } from 'next-i18next'

const TradeTime = memo(function TradeTime({ time }: { time: number }) {
  const { t } = useTranslation('trade')
  const [elapsedTime, setElapsedTime] = useState(0)

  const updateElapsedTime = useCallback(() => {
    const diffInSeconds = Math.floor((Date.now() - time) / 1000)
    setElapsedTime(diffInSeconds)
  }, [time])

  useGlobalTick(updateElapsedTime)

  const formattedTime = useMemo(() => {
    if (elapsedTime < 0) return '0s'
    if (elapsedTime < 60) return t('time.seconds', { seconds: elapsedTime })
    if (elapsedTime < 3600)
      return t('time.minutes', { minutes: Math.floor(elapsedTime / 60) })
    if (elapsedTime < 86400)
      return t('time.hours', { hours: Math.floor(elapsedTime / 3600) })
    return t('time.days', { days: Math.floor(elapsedTime / 86400) })
  }, [elapsedTime, t])

  return <>{formattedTime}</>
})

export default TradeTime
